export const ERROR_PAGE_SET_ERROR = 'ERROR_PAGE_SET_ERROR';
export const ERROR_PAGE_CLEAR_ERROR = 'ERROR_PAGE_CLEAR_ERROR';
